import { TFunction } from 'react-i18next';
import { dictionaryFromTypeOptionsTranslated } from './helpers';
import { dictionaryAassignmentTypeOptionsTranslated } from './dialogs/ActionWizard/subsections/AssignTeamMember/common';

export type MessageDictionaryKeys =
  | 'dictionaryFromTypeOptions'
  | 'dictionaryAassignmentTypeOptions'
  | 'automationFailedToLoad'
  | 'automationFailedPrefix'
  | 'automationFailedSuffix'
  | 'anyStage'
  | 'automation'
  | 'associatedItem'
  | 'associatedRole'
  | 'deleted'
  | 'deletedRole'
  | 'deletedStep'
  | 'field'
  | 'relatedObjectField'
  | 'targetRelationshipFields'
  | 'teamMember'
  | 'theAutomationMessageName'
  | 'thereWasanErrorLoadingThe'
  | 'thereWasanErrorLoadingTheAssociatedInbox'
  | 'thereWasanErrorLoadingTheAssociatedRole'
  | 'thereWasanErrorLoadingTheAssociatedGroup'
  | 'thereWasanErrorLoadingTheAssociatedStage'
  | 'thereWasanErrorLoadingTheAssociatedTag'
  | 'thereWasanErrorLoadingTheAssociatedItem'
  | 'thereWasanErrorLoadingTheAssociatedFilters'
  | 'sourceTargetValueMayNotBeBlank'
  | 'targetValueMayNotBeBlank'
  | 'onlyOneFromValueMayBeLeftAsNull'
  | 'integratedInbox'
  | 'notUpdated'
  | 'activities'
  // variables
  | 'objectHasBeenDeleted'
  | 'objectRecordHasBeenDeleted'
  | 'teamMemberHasBeenDeleted'
  | 'fieldDeleted'
  // logged_activity_trigger variables
  | 'activityDeleted'
  | 'activityFieldValueDeleted'
  | 'associatedObjectDeleted'
  | 'activityUsedAsVariableSource'
  | 'variableUseInStep'
  | 'variableErrorLoading'
  | 'llmPluginAppIsMissing'
  | 'missingPlugin'
  | 'updatedPluginConfig'
  | 'webhookTriggerDeleted'
  | 'webhookTriggerValueDeleted'
  | 'missingPluginConfig'
  | 'deletedOverrideVariable'
  | 'fieldsToClear'
  | 'inactiveAutomation'
  | 'runBranchesInParallel'
  | 'runBranchesInParallelThenMerge'
  | 'nextFinishDescription'
  | 'loopArrayVariableDeleted'
  | 'runToolsAs';

export type MessageDictionary = Record<MessageDictionaryKeys, string>;
export type AddErrorMessage = (message: string) => void;

export const translatedMessageDictionary = (
  t: TFunction,
  isGlobalAutomation = false
) => ({
  dictionaryFromTypeOptions: dictionaryFromTypeOptionsTranslated(
    t,
    true,
    false,
    false,
    isGlobalAutomation
  ),
  dictionaryAassignmentTypeOptions: dictionaryAassignmentTypeOptionsTranslated(
    isGlobalAutomation,
    t
  ),
  automationFailedToLoad: t(
    'Agentic Workflow failed to load a step, please edit before saving.'
  ),
  automationFailedPrefix: t(' and '),
  automationFailedSuffix: t(' more.'),
  anyStage: t('Any Stage'),
  automation: t('Agentic Workflow'),
  associatedItem: t('Associated Item'),
  associatedRole: t('Associated Role'),
  deleted: t('[Deleted]'),
  deletedRole: t('[Deleted] Role'),
  deletedStep: t('[Deleted] Step'),
  field: t('Field'),
  relatedObjectField: t('Related Object Field'),
  targetRelationshipFields: t('Target Relationship Fields'),
  teamMember: t('Team Member'),
  theAutomationMessageName: t('The Agentic Workflow Message name'),
  thereWasanErrorLoadingThe: t('There was an error loading the'),
  thereWasanErrorLoadingTheAssociatedInbox: t(
    "There was an error loading the 'Associated Integrated Inbox'."
  ),
  thereWasanErrorLoadingTheAssociatedRole: t(
    "There was an error loading the 'Associated Role'."
  ),
  thereWasanErrorLoadingTheAssociatedGroup: t(
    "There was an error loading the 'Associated Group'."
  ),
  thereWasanErrorLoadingTheAssociatedStage: t(
    "There was an error loading the 'Associated Stage'."
  ),
  thereWasanErrorLoadingTheAssociatedTag: t(
    "There was an error loading the 'Associated Tag'."
  ),
  thereWasanErrorLoadingTheAssociatedItem: t(
    "There was an error loading the 'Associated Item'."
  ),
  thereWasanErrorLoadingTheAssociatedFilters: t(
    "There was an error loading the 'Associated Filters'."
  ),
  sourceTargetValueMayNotBeBlank: t('Source or Target value may not be blank'),
  targetValueMayNotBeBlank: t('Target value may not be blank'),
  onlyOneFromValueMayBeLeftAsNull: t(
    'Only one "from" value may be left as null.'
  ),
  integratedInbox: t('Integrated Inbox'),
  notUpdated: t(
    'The agentic workflow has been updated, please reload the agentic workflow to get the latest version.'
  ),
  activities: t('Activities'),
  // variables
  objectHasBeenDeleted: t('The Object has been deleted'),
  objectRecordHasBeenDeleted: t('The Object Record has been deleted'),
  loopArrayVariableDeleted: t(
    'The Array Variable this loop iterates has been deleted'
  ),
  teamMemberHasBeenDeleted: t('The Team Member has been deleted'),
  fieldDeleted: t('Field deleted'),
  // logged_activity_trigger variables
  activityDeleted: t('The Activity has been deleted'),
  activityFieldValueDeleted: t('The Activity Field has been deleted'),
  associatedObjectDeleted: t('The Associated Object has been deleted'),
  // webhook_trigger variables
  webhookTriggerDeleted: t('The Webhook Trigger has been deleted'),
  webhookTriggerValueDeleted: t('The Webhook Trigger Value has been deleted'),
  // variables in use
  activityUsedAsVariableSource: t(
    'The activity was used as a variable source, some variables are now invalid'
  ),
  variableUseInStep: t(
    'The variable was used in steps, they are are now invalid'
  ),
  variableErrorLoading: t('There was an error loading the variable'),
  llmPluginAppIsMissing: t('LLM Plugin App is missing'),
  missingPlugin: t('The Plugin App is missing'),
  updatedPluginConfig: t(
    'The Plugin config as been updated and the step needs editing'
  ),
  missingPluginConfig: t(
    'The Plugin config no longer exist and the step needs editing'
  ),
  deletedOverrideVariable: t(
    'Target agentic workflow variable has been deleted: '
  ),
  fieldsToClear: t('Fields to clear'),
  inactiveAutomation: t('One or more agentic workflows are not active'),
  runBranchesInParallel: t('Run Branches in Parallel'),
  runBranchesInParallelThenMerge: t('Run Branches in Parallel, then Merge'),
  nextFinishDescription: t('Next item or finish loop and continue'),
  runToolsAs: t('Run Tools As'),
});
